import React from 'react'
// import { BsLinkedin } from 'react-icons/bs'
// import { BsGithub } from 'react-icons/bs'
// import { BsDribbble } from 'react-icons/bs'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faYoutube,
  faFacebook,
  // faTwitter,
  // faInstagram,
  // faLinkedin,
  faGithub,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";

const HomeSocial = () => {
  return (
    <div className="home__social">
       {/* <a href="https://www.youtube.com/"
        className="youtube social">
        <FontAwesomeIcon icon={faYoutube} size="2x" />
      </a> */}
      <a href="https://www.linkedin.com/in/rabihnd/"
        className="Linkedin social">
        <FontAwesomeIcon icon={faLinkedinIn} size="2x" />
        </a>
      <a href="https://www.facebook.com/"
        className="facebook social">
        <FontAwesomeIcon icon={faFacebook} size="2x" />
      </a>
      <a href="https://github.com/RabihND" className="github social">
        <FontAwesomeIcon icon={faGithub} size="2x" />
      </a>
      {/* <a href="https://www.instagram.com/"
        className="instagram social">
        <FontAwesomeIcon icon={faInstagram} size="2x" />
      </a> */}
    </div>
  )
}

export default HomeSocial